"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Box_1 = require("../Box");
var StyledAlert_1 = require("./StyledAlert");
var themes_1 = require("../../themes");
var icons_1 = require("../../icons");
var Icon_1 = require("../Icon");
exports.Alert = function (_a) {
    var onClose = _a.onClose, children = _a.children, _b = _a.textSize, textSize = _b === void 0 ? 'medium' : _b, _c = _a.hideAlertIcon, hideAlertIcon = _c === void 0 ? false : _c, rest = tslib_1.__rest(_a, ["onClose", "children", "textSize", "hideAlertIcon"]);
    var renderAlertMessage = function () {
        var renderTag = typeof children === 'string' || Array.isArray(children) ? 'p' : 'div';
        if (Array.isArray(children)) {
            return Object(children).map(function (value, index) {
                return (react_1.default.createElement(StyledAlert_1.StyledAlertMessage, { role: "alert", key: index, tag: renderTag, size: textSize }, value));
            });
        }
        return (react_1.default.createElement(StyledAlert_1.StyledAlertMessage, { role: "alert", tag: renderTag, size: textSize }, children));
    };
    return (react_1.default.createElement(StyledAlert_1.StyledAlert, { align: "center" },
        react_1.default.createElement(Box_1.Box, tslib_1.__assign({ pad: { horizontal: 'large', vertical: 'medium' }, direction: "row", gap: "large" }, rest),
            !hideAlertIcon && (react_1.default.createElement(Box_1.Box, { flex: false, width: '24px' },
                react_1.default.createElement(Icon_1.Icon, { icon: icons_1.AlertCircle, id: "alert", width: "24px", height: "24px" }))),
            react_1.default.createElement(Box_1.Box, null, renderAlertMessage()),
            onClose && (react_1.default.createElement(Box_1.Box, { margin: { top: '4px' }, flex: false, width: '24px' },
                react_1.default.createElement(Icon_1.IconButton, { label: "close alert", onClick: onClose, iconProps: {
                        id: 'close_alert',
                        icon: icons_1.Clear,
                        fill: themes_1.colors.white,
                        width: '16px',
                        height: '16px'
                    } }))))));
};
//# sourceMappingURL=Alert.js.map